import {useCallback, useSyncExternalStore} from 'react'

import {createCookieBackedSet} from './cookie-backed-set'

const emptySections = createCookieBackedSet('dashboard_surface_empty_sections')

const noop = () => () => {}
const alwaysFalse = () => false

/**
 * Remembers, across reloads, whether an inbox section was empty the last time it
 * loaded. This lets a section that we already know is empty skip the loading
 * skeleton (which would otherwise flash and then immediately auto-collapse) while
 * it re-fetches.
 *
 * @param sectionId The inbox section ID (e.g. 'review-requested').
 */
export function useSectionEmptyMemory(sectionId: string) {
  const knownEmpty = useSyncExternalStore(noop, () => emptySections.has(sectionId), alwaysFalse)

  const recordEmptiness = useCallback(
    (isEmpty: boolean) => {
      emptySections.set(sectionId, isEmpty)
    },
    [sectionId],
  )

  return {knownEmpty, recordEmptiness}
}
